import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import CookiePrivacyPolicyPopup from "@insite/content-library/Components/CookiePrivacyPolicyPopup";
import Page from "@insite/mobius/Page";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface FooterStyles {
    footercontainer?: InjectableCss;
}
export const footerStyles: FooterStyles = {
    footercontainer: {
        css: css`
            backgroud-color: red;
            > div > div[class^="GridWrapper"] {
                max-width: 100%;
            }
        `,
    },
};
const styles = footerStyles;

const Footer: React.FunctionComponent<PageProps> = ({ id }: PageProps) => (
    <Page as="footer" fullWidth={[true, true, true, true, true]} isFooter={true} {...styles.footercontainer}>
        <Zone contentId={id} zoneName="Content" />
        <CookiePrivacyPolicyPopup />
    </Page>
);

const pageModule: PageModule = {
    component: Footer,
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "System",
    },
};

export default pageModule;
export const FooterContext = "Footer";
